import React from 'react';
import type { TypeChatNotifyPrefs } from '@/types/conversation/types.conversation.chat.channel';

const KEY = 'bd-chat-notify-prefs';
const DEFAULTS: TypeChatNotifyPrefs = { level: 'all', desktop: false, sound: true, preview: true };

const listeners = new Set<() => void>();

const load = (): TypeChatNotifyPrefs => {
    try {
        const raw = JSON.parse(window.localStorage.getItem(KEY) ?? '{}') as Partial<TypeChatNotifyPrefs>;
        return {
            level: raw.level === 'important' || raw.level === 'none' ? raw.level : 'all',
            desktop: raw.desktop === true,
            sound: raw.sound !== false,
            preview: raw.preview !== false,
        };
    } catch {
        return DEFAULTS;
    }
};

let prefs: TypeChatNotifyPrefs = typeof window === 'undefined' ? DEFAULTS : load();

export const getChatNotifyPrefs = (): TypeChatNotifyPrefs => prefs;

export const setChatNotifyPrefs = (patch: Partial<TypeChatNotifyPrefs>): void => {
    prefs = { ...prefs, ...patch };
    try {
        window.localStorage.setItem(KEY, JSON.stringify(prefs));
    } catch {
        return;
    } finally {
        listeners.forEach((listener) => listener());
    }
};

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
};

export const useChatNotifyPrefs = (): TypeChatNotifyPrefs => React.useSyncExternalStore(subscribe, getChatNotifyPrefs, () => DEFAULTS);
